import React, { useState } from 'react';

import SAlert, { type SAlertProps } from 'Components/structural/SAlert/SAlert';
import type { InferPushQueueItem } from 'Libs/queue/redux/utils';

import { AI_COURSE_VIEWS } from 'Pages/Courses/Edition/views';
import { type CourseEdited } from 'Pages/Courses/redux';
import { type MkQueueHandler } from 'Pages/Courses/utils/edition-handlers';
import AICourseInitial from 'Pages/Courses/Edition/views/AIInitial/AIInitial';
import AILoading from 'Pages/Courses/Edition/views/AILoading/AILoading';
import AIMkValidation from 'Pages/Courses/Edition/views/AIMkValidation/AIMkValidation';
import AIPlanValidation from 'Pages/Courses/Edition/views/AIPlanValidation/AIPlanValidation';
import styles, { type AlertStyleName } from 'Pages/Courses/Edition/views/ViewManager/ViewManager.style';
import useAICourseView from 'Pages/Courses/Edition/hooks/useAICourseView';

type ViewManagerProps = {
  course?: CourseEdited;
  push: (item: InferPushQueueItem<MkQueueHandler>) => void;
};

export type displayAlertParams = Partial<SAlertProps> & { duration?: number };

const ViewManager: React.FC<ViewManagerProps> = ({ push, course }) => {
  const { viewType } = useAICourseView();

  if (!course || !course.id) {
    return null;
  }

  const DEFAULT_ALERT_DURATION = 5000;
  const [alertStyle, setAlertStyle] = useState<AlertStyleName>('alert_inital');
  const [alertParams, setAlertParams] = useState<Partial<SAlertProps>>({});
  const displayAlert = (params: displayAlertParams) => {
    setAlertStyle('alert_final');
    setAlertParams(params);
    setTimeout(() => {
      setAlertStyle('alert_inital');
      setAlertParams({});
    }, params.duration || DEFAULT_ALERT_DURATION);
  };
  const closeAlert = () => {
    setAlertStyle('alert_inital');
    setAlertParams({});
  };

  return (
    <>
      {viewType === AI_COURSE_VIEWS.INITIAL && <AICourseInitial course={course} displayAlert={displayAlert} />}
      {viewType === AI_COURSE_VIEWS.LOADING_PLAN && <AILoading contentType="course" />}
      {viewType === AI_COURSE_VIEWS.LOADING_MICROKNOWLEDGES && <AILoading contentType="microknowledges" />}
      {viewType === AI_COURSE_VIEWS.PLAN_VALIDATION && <AIPlanValidation push={push} displayAlert={displayAlert} />}
      {viewType === AI_COURSE_VIEWS.MICROKNOWLEDGES_VALIDATION && <AIMkValidation push={push} />}
      <SAlert
        title={alertParams?.title}
        text={alertParams?.text}
        status={alertParams?.status || 'error'}
        icon={alertParams?.icon || 'error'}
        style={styles[alertStyle]}
        onClose={closeAlert}
      />
    </>
  );
};

export default ViewManager;
